export default (t) => [
  {
    text: t('Number'),
    value: 'number',
    sortable: false,
    fixed: false,
    width: 150
  },
  {
    text: t('Branch'),
    value: 'branch',
    sortable: true,
    fixed: false,
    width: 100
  },
  {
    text: t('Quantity'),
    value: 'quantity',
    sortable: true,
    fixed: false,
    width: 100
  },
  {
    text: t('Remaining'),
    value: 'remaining_quantity',
    sortable: true,
    fixed: false,
    width: 100
  },
  {
    text: t('Cost'),
    value: 'cost',
    sortable: false,
    width: 125
  },
  {
    text: t('Received'),
    value: 'received_date',
    sortable: false,
    width: 100
  },
  {
    text: t('Expiry'),
    value: 'expiry_date',
    sortable: false,
    width: 100
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 150
  },
];
